export default {
  get country() {
    if (!this.countries || !this.countries.length) {
      return undefined;
    }

    return this.countries.map((c) => c.name).join(', ');
  },
};
